// Utility functions for theme-based configurations

export const getAppName = (): string => {
  const theme = process.env.REACT_APP_THEME || 'default';
  return theme === 'adpercepta' ? 'AdPercepta Ad Manager' : 'ExtraStreamer Cloud';
};

export const getLogoPath = (): string => {
  const theme = process.env.REACT_APP_THEME || 'default';
  return theme === 'adpercepta' ? '/adpercepta.png' : '/logo.svg';
};
